import { useEffect, useState } from "react";
import BasicDropdown from "../ui/forms/dropdown/BasicDropdown";
import { AsyncDropdown } from "../ui/forms/dropdown/AsyncDropdown";
import { searchTeams } from "../../services/teamsAPI";
import { getAllSeasons } from "../../services/seasonsAPI";
import { getDDLeagueNames } from "../../services/leaguesAPI";
import {
  toTeamOption,
  toLeagueOption,
  toSeasonOption,
} from "../ui/forms/dropdown/ddLabels";
import { createGame, updateGame } from "../../services/gamesAPI";
import { toInputDateFormat } from "../../utils/dateAndTime";
import { toast } from "react-toastify";
import { Button } from "../ui/btns/Button";
// CREATE GAME IS NOW USED FOR UDPATE ALSO
export const CreateGame = ({ game, id, handleClose, fetchGame }) => {
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    date: "",
    description: "",
    season: null,
    round: "",
    league: null,
    homeTeam: null,
    awayTeam: null,
    gameType: "",
  });

  // SET INITIAL DATA (FILL BY DEFAULT DATA FOR UPDATE)
  useEffect(() => {
    if (game) {
      setFormData({
        date: game.date ? toInputDateFormat(game.date) : "",
        description: game.description || "",
        season: game.season
          ? { value: game.season, label: game?.SeasonDetails?.season }
          : null,
        round: game.round || "",
        homeTeam: game.homeTeam
          ? {
              value: game.homeTeam,
              label: `${game?.HomeTeamDetails?.city} ${game?.HomeTeamDetails?.name}`,
            }
          : null,
        awayTeam: game.awayTeam
          ? {
              value: game.awayTeam,
              label: `${game?.AwayTeamDetails?.city} ${game?.AwayTeamDetails?.name}`,
            }
          : null,
        league: game.league
          ? { value: game.league, label: game?.LeagueDetails?.name }
          : null,
        gameType: game.gameType || "",
      });
    }
  }, [game]);

  const handleChange = (input) => {
    if (input.target) {
      // Standard HTML input handling
      const { name, value } = input.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      // react-select input handling, assuming input is { value, label }
      const { name, value } = input;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleDropdownChange = (selectedOption, name) => {
    handleChange(
      selectedOption ? { name, value: selectedOption } : { name, value: null }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.date) {
      toast.error("Date is required", { autoClose: 5000 });
      return;
    }
    if (!formData.season) {
      toast.error("Season is required", { autoClose: 5000 });

      return;
    }
    if (!formData.league) {
      toast.error("League is required", { autoClose: 5000 });
      return;
    }
    if (!formData.homeTeam) {
      toast.error("Home team is required", { autoClose: 5000 });
      return;
    }
    if (!formData.awayTeam) {
      toast.error("Away team is required", { autoClose: 5000 });
      return;
    }

    // Create a new FormData object
    const formDataToSend = new FormData();

    // Append form data fields
    formDataToSend.append("date", formData.date);
    formDataToSend.append("season", formData.season ? formData.season.value : "");
    formDataToSend.append("gameType", formData.gameType);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("round", formData.round);
    formDataToSend.append("league", formData.league ? formData.league.value : "");
    formDataToSend.append("homeTeam", formData.homeTeam ? formData.homeTeam.value : "");
    formDataToSend.append("awayTeam", formData.awayTeam ? formData.awayTeam.value : "");

    let response;
    setIsPending(true);
    if (id) {
      response = await updateGame(id, formDataToSend);
      if (!response?.success) {
        toast.error("Error updating game", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      toast.success("Game updated successfully");
      fetchGame();
      handleClose();
      setIsPending(false);
    } else {
      response = await createGame(formDataToSend);
      if (!response?.success) {
        toast.error("Error creating game", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      toast.success("Game created successfully");
      setIsPending(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="font-heading text-xl font-black uppercase tracking-wide text-flyers-orange mb-4">
        {" "}
        {id ? "Update Game" : "Create Game"}
      </h1>
      <form
        onSubmit={handleSubmit}
        className="bg-flyers-charcoal border border-flyers-dark-gray p-6 rounded-lg w-full max-w-md"
      >
        <div className="mb-4">
          <label htmlFor="date" className="label">
            Date
          </label>
          <input
            type="date"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            className="input-new"
            placeholder="Select Start Date"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="season" className="label">
            Season
          </label>
          <BasicDropdown
            id="season"
            name="season"
            options={[]} // You can pass options array here if they're available immediately
            placeholder="Select a Season"
            handleChange={handleDropdownChange}
            isSearchable={true}
            value={formData.season}
            toOptionLabel={toSeasonOption}
            apiFunction={getAllSeasons}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="gameType" className="label">
            Game Type
          </label>
          <input
            type="text"
            id="gameType"
            name="gameType"
            value={formData.gameType}
            onChange={handleChange}
            placeholder="Enter Game Type"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="round" className="label">
            Round
          </label>
          <input
            type="text"
            id="round"
            name="round"
            value={formData.round}
            onChange={handleChange}
            placeholder="Enter Round"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="label">
            Description
          </label>
          <input
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter Description"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="league" className="label">
            League
          </label>
          <BasicDropdown
            id="league"
            name="league"
            options={[]} // You can pass options array here if they're available immediately
            placeholder="Select a League"
            handleChange={handleDropdownChange}
            isSearchable={true}
            value={formData.league}
            toOptionLabel={toLeagueOption}
            apiFunction={getDDLeagueNames}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="homeTeam" className="label">
            Home Team
          </label>
          <AsyncDropdown
            id="homeTeam"
            name="homeTeam"
            apiFunction={searchTeams}
            toOptionLabel={toTeamOption}
            placeholder="Search Home Teams..."
            isClearable={true}
            handleChange={handleDropdownChange}
            value={formData.homeTeam}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="awayTeam" className="label">
            Away Team
          </label>
          <AsyncDropdown
            id="awayTeam"
            name="awayTeam"
            apiFunction={searchTeams}
            toOptionLabel={toTeamOption}
            placeholder="Search Away Teams..."
            isClearable={true}
            handleChange={handleDropdownChange}
            value={formData.awayTeam}
          />
        </div>
        <Button variant="primary" type="submit" className="w-full" disabled={isPending}>
          {id ? "Update Game" : "Create Game"} {isPending && "..."}
        </Button>
      </form>
    </div>
  );
};
